import { z } from 'zod';
import {
    mockSnapshot,
    Snapshot,
    snapshotSchema,
} from 'app/agriculture/queries/snapshots/types/Snapshot';

export interface WeatherSnapshot extends Snapshot {
    /**
     * Total luminous flux incident on a surface, per unit area
     * @subtype integer
     * @units lux
     */
    illuminance: number | null;
    /**
     * 1-2: Low,
     * 3-5: Moderate,
     * 6-7: High,
     * 8-10: Very High,
     * 11+: Extreme
     * @subtype float
     * @units
     */
    uvIndex: number | null;
    /**
     * @subtype float
     * @units Celsius (°C)
     */
    temperature: number | null;

    /**
     * @subtype float
     * @units %
     */
    humidity: number | null;
    /**
     * @subtype float
     * @units mm
     */
    deltaRainfall: number | null;
    /**
     * @subtype float
     * @units hPa
     */
    absPressure: number | null;

    /**
     * @subtype float
     * @units m/s
     */
    windSpeed: number | null;
    /**
     * @subtype float
     * @units m/s
     */
    gustSpeed: number | null;
    /**
     * @subtype float
     * @units degrees
     */
    windDirection: number | null;
}

export const weatherSnapshotSchema = snapshotSchema.extend({
    illuminance: z.number().nullable(),
    uvIndex: z.number().nullable(),
    temperature: z.number().nullable(),

    humidity: z.number().nullable(),
    deltaRainfall: z.number().nullable(),
    absPressure: z.number().nullable(),

    windSpeed: z.number().nullable(),
    gustSpeed: z.number().nullable(),
    windDirection: z.number().nullable(),
});

export const mockWeatherSnapshot = ({
    illuminance = null,
    uvIndex = null,
    temperature = null,

    humidity = null,
    deltaRainfall = null,
    absPressure = null,

    windSpeed = null,
    gustSpeed = null,
    windDirection = null,

    ...snapshot
}: Partial<WeatherSnapshot> = {}): WeatherSnapshot => ({
    ...mockSnapshot(snapshot),

    illuminance,
    uvIndex,
    temperature,

    humidity,
    deltaRainfall,
    absPressure,

    windSpeed,
    gustSpeed,
    windDirection,
});
